
// const enums = (locale) => {
//   if (locale === 'cn' || locale === 'tw') {
//     return {
//       session_type: [
//         "现场会议", // 0
//         "直播会议",// 1
//         "互动会议",// 2
//       ],

//       //邀请发送状态
//       invitation_sending_status: [
//         "草稿",
//         "等待中",
//         "进行中",
//         "完成",
//       ],

//       //邀请确认状态
//       invitation_confirm_status: [
//         "CONFIRMED",
//         "REJECTED",
//         "PENDING",
//       ]
//     }
//   } else {
//     return {
//       //会议类型
//       session_type: [
//         "ONSITE", // 0
//         "BROADCAST",// 1
//         "INTERACTIVE MEETING",// 2
//       ],

//       //邀请发送状态
//       invitation_sending_status: [
//         "DRAFT",
//         "WAITING_PROCESS",
//         "PROCESSING",
//         "FINISHED",
//       ],

//       //邀请确认状态
//       invitation_confirm_status: [
//         "CONFIRMED",
//         "REJECTED",
//         "PENDING",
//       ]

//     }
//   }
// }

const enums = {
    //会议类型
    session_type: [
        "ONSITE", // 0
        "BROADCAST",// 1
        "INTERACTIVE MEETING",// 2
        "PLAYBACK",//3
        "RECORDED", //4
        "BROADCAST_CASTER",//5
        "ACTIVITY",//6
    ],
    associated_property: [
      "general",
      "recorded",
      "playback"
    ],

    //邀请发送状态
    invitation_sending_status: [
        "DRAFT",
        "WAITING_PROCESS",
        "PROCESSING",
        "FINISHED",
    ],

    //邀请确认状态
    invitation_confirm_status: [
        "CONFIRMED",
        "REJECTED",
        "PENDING",
    ],
    //运动的阶段
    sport_stage:{
      "0": "ready",
      "1": "registration",
      "2": "activity",
      "3": "end"
    }
}

export default enums;



// WEBPACK FOOTER //
// ./src/libs/enums.js